import { useEffect, useState } from "react";

// true after `ms` without a pointer or key, so a play can show its hint again; resets on any interaction
export function useIdle(ms = 8000) {
  const [idle, setIdle] = useState(false);
  useEffect(() => {
    let id;
    const reset = () => {
      setIdle(false);
      clearTimeout(id);
      id = setTimeout(() => setIdle(true), ms);
    };
    reset();
    window.addEventListener("pointerdown", reset);
    window.addEventListener("pointermove", reset);
    window.addEventListener("keydown", reset);
    return () => {
      clearTimeout(id);
      window.removeEventListener("pointerdown", reset);
      window.removeEventListener("pointermove", reset);
      window.removeEventListener("keydown", reset);
    };
  }, [ms]);
  return idle;
}
